import React from 'react'
import css from './style.scss'
import ReactDOM from 'react-dom'
import CloseIcon from 'react-icons/lib/md/close'
import {FullContainer} from 'components/container'
import Button from 'components/shared/button'
import {NormalInput as Input} from 'components/shared/input'
import StoriesList from 'components/account_page/stories/list/index'
import cn from 'classnames'
import api from './api'
import store from 'utils/store'
import {push} from 'react-router-redux'


class Adventure extends React.Component{
  constructor(props){
    super(props)
    console.log("props", props)
    this.state={
      compact:true,
      name:""
    }
  }
  selectedPosts=()=>{
    if(this.props.adventure){
      api.updateAdventure(this.props.account.id, this.props.adventure, this.props.stories.map(s=>s.id)).then(response=>{
        store.dispatch({type:"ADD_TOAST", message:"Stories updated for adventure "+this.props.adventure.name})
        this.props.onClose()
        store.dispatch(push("/a/"+this.props.account.id+"/adventures/"+this.props.adventure.id))
      })
    }else{
      this.setState({compact:false})
      setTimeout(()=>{
        this.name.focus()
      },500)
    }

  }
  selectCompactUI=()=>{
    this.setState({compact:true})
  }
  compactUI=()=>{
    return (
      <div className={css.adventureBar}>
        <button className={css.close} onClick={this.props.onClose}>
          <CloseIcon size={24}/>
        </button>
        <p>{this.props.stories.length} stories selected</p>
        <Button className={css.button} onClick={this.selectedPosts}>
          { this.props.adventure ? "Add stories to "+this.props.adventure.name : "Create adventure"}
        </Button>
      </div>
    )
  }
  storeName=(e)=>{
    this.setState({name:e.target.value})
  }
  createAdventure=()=>{
    if(this.state.name.length===0){
      store.dispatch({type:"ADD_TOAST", message:"Add a name to your adventure!"})
      this.name.focus()
      return
    }
    if(this.props.stories.length===0){
      store.dispatch({type:"ADD_TOAST", message:"Select at least a story for this adventure."})
      this.setState({compact:true})
      return
    }
    api.createAdventure(this.props.account.id, this.state.name, this.props.stories.map(s=>s.id)).then(response=>{
      store.dispatch({type:"ADD_TOAST", message:"You just created a new adventure!"})
      this.props.onClose()
    })
  }

  extendedUI=()=>{
    return (
      <div>
        <div className={cn(css.adventureBar, css.adventureBarExtended)}>
          <button className={css.close} onClick={this.props.onClose}>
            <CloseIcon size={24}/>
          </button>
          <p>New Adventure</p>
        </div>
        <div className={css.adventureMore}>
          <Input onChange={this.storeName} name="name" type="text" placeholder="Name..." big ref={(i)=>this.name=i}/>
          <p className={css.selectStories}>You selected <b>{this.props.stories.length} stories</b> for this adventure.</p>
          {this.props.stories.length>0 && <StoriesList onlyStories={true} stories={this.props.stories}/>}
          <div className={css.submitContainer}>
            <Button small className={css.selectMoreButton} onClick={this.selectCompactUI}>Select more stories</Button>
            <Button primary className={css.submitButton} onClick={this.createAdventure}>Create adventure</Button>
          </div>
        </div>
      </div>
    )
  }


  render(){
    let modalEl=document.getElementById("modals");
    return ReactDOM.createPortal(
      (
        <FullContainer noAnimation className={css.adventureBarContainer}>
          {this.state.compact && this.compactUI()}
          {!this.state.compact && this.extendedUI()}
        </FullContainer>
      ),
    modalEl,
    );
  }


}


export default Adventure;



// WEBPACK FOOTER //
// ./src/components/account_page/stories/adventure/adventure_bar.js